export const NotFound = () => {
  return (
    <div className="main-content-holder">
      <div className="article-holder">
        <p>Not found 🤷‍♂️</p>
      </div>
    </div>
  )
}